import { ReactNode } from 'react';

import { TEXT } from 'core/table/cellTypes';

type ColumnOptions<Data, Property = keyof Data> = {
  displayName?: string;
  dataProperty?: Property;
  type?: string;
  sortable?: boolean;
  width?: number;
  getCellContent?: (props: { rowData: Data }) => ReactNode;
  formatter?: (
    value: Property extends keyof Data ? Data[Property] : never,
    rowData: Data,
  ) => ReactNode;
  getTooltip?: (rowData: Data) => string;
};

export const createColumn = <Data, Property = keyof Data>({
  displayName,
  type = TEXT,
  sortable = true,
  dataProperty,
  width,
  getCellContent: CellContent,
  formatter,
  getTooltip,
}: ColumnOptions<Data, Property>) => ({
  name: displayName,
  value: dataProperty,
  verticalAlign: 'middle',
  getCellContent: CellContent,
  formatter,
  type,
  sortable,
  width,
  getTooltip,
});
